export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type: 'Container', 
              name: "Container Eventos",
              attributes: { class: 'container-cubo align-center' },
              components: [
                {
                    type: 'columnsEvents2'
                }
              ],
              styles: `
               .container-cubo{
                max-width: 1600px; 
             }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};